"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var types_1 = require("../types");
var helpers_1 = require("../../helpers");
var FillSpaceStyled = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    flex: 1 1 auto;\n    &[data-fill-space='true'] {\n        margin-left: 0;\n    }\n"], ["\n    flex: 1 1 auto;\n    &[data-fill-space='true'] {\n        margin-left: 0;\n    }\n"])));
var UIFillSpaceBase = helpers_1.createUIElement('FillSpace', function (_a, ref) {
    var className = _a.className, style = _a.style, rest = __rest(_a, ["className", "style"]);
    return (react_1.default.createElement(FillSpaceStyled, __assign({}, rest, { "data-selector-id": rest['data-selector-id'] || 'toolbar-fillspace', className: "vm-FillSpace " + className, "data-fill-space": true, ref: ref, style: style })));
});
exports.FillSpace = Object.assign({}, UIFillSpaceBase, {
    itemType: types_1.TOOLBAR_ITEM_TYPE.fillSpace
});
var templateObject_1;
//# sourceMappingURL=FillSpace.js.map